// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { MsalProvider } from '@azure/msal-react'
import { IPublicClientApplication } from '@azure/msal-browser'
// @ts-ignore
import OneDriveIcon from '../../../assets/images/onedrive-logos.svg'
import ProvideAppContext from './AppContext'
import ErrorMessage from './ErrorMessage'
import Welcome from './Welcome'
import React from 'react'
import { Grid, Paper } from '@mui/material'

type AppProps = {
    pca: IPublicClientApplication
}

export default function SharePoint({ pca }: AppProps): JSX.Element {
    return (
        <MsalProvider instance={pca}>
            <ProvideAppContext>
                <Paper>
                    <Grid container wrap={'nowrap'} style={{ marginTop: '15px' }}>
                        <Grid item>
                            <img
                                src={OneDriveIcon}
                                alt="activity icon"
                                style={{ width: '64px', height: '42px', marginLeft: '20px' }}
                            />
                        </Grid>
                        <Grid item>
                            <ErrorMessage />
                        </Grid>
                        <Grid item>
                            <Welcome />
                        </Grid>
                    </Grid>
                </Paper>
            </ProvideAppContext>
        </MsalProvider>
    )
}
